
interface Config {
  siteType: 'frankfort';
  candidateName: string;
  campaignName: string;
  officeSought: string;
  jurisdiction: string;
  canonicalUrl: string;
  logo: string;
  social: {
    facebook: string;
    facebookHandle: string;
  };
  donations: {
    url: string;
    description: string;
    imageUrl: string;
  };
  contact: {
    email: string;
    phone: string;
    city: string;
  };
  pages: {
    home: {
      hero: {
        title: string;
        subtitle: string;
        imageUrl: string;
      };
      about: {
        title: string;
        text: string;
        imageUrl: string;
      };
      issues: {
        title: string;
        issues: { title: string; text: string; }[];
      };
      endorsements?: {
        title: string;
        endorsements: { name: string; title: string; }[];
      };
    };
    about: {
      title: string;
      text: string;
      imageUrl: string;
    };
    issues: {
      title: string;
      issues: { title: string; text: string; }[];
    };
    endorsements?: {
        title: string;
        endorsements: { name: string; title: string; }[];
    };
    getInvolved: {
      title: string;
      text: string;
    };
    contact: {
      title: string;
      text: string;
    };
  };
}

const frankfortConfig: Config = {
  siteType: 'frankfort',
  candidateName: 'Todd Frankfort',
  campaignName: 'Todd Frankfort for Judge',
  officeSought: '240th District Court Judge',
  jurisdiction: 'Fort Bend County, Texas',
  canonicalUrl: 'https://www.frankfortforjudge.org',
  logo: 'Frankfort_Logo_2026_red_v2_1200.avif',
  social: {
    facebook: 'https://www.facebook.com/ToddFrankfortforJudge/',
    facebookHandle: 'TBD',
  },
  donations: {
    url: '#', // TODO: Add official donation link
    description: 'Support Todd Frankfort for Judge',
    imageUrl: '39838a_a43017b268e345708dbd99bf85a22ab1~mv2.avif',
  },
  contact: {
    email: 'info@frankfortforjudge.com',
    phone: 'XXX-XXX-XXXX', // TODO: Find phone number
    city: 'TBD',
  },
  pages: {
    home: {
      hero: {
        title: 'Todd Frankfort for Judge',
        subtitle: 'Experienced, Fair, and a Lifelong Republican.',
        imageUrl: '39838a_a43017b268e345708dbd99bf85a22ab1~mv2.avif',
      },
      about: {
        title: 'About Todd Frankfort',
        text: `Todd Frankfort is a dedicated legal professional with deep roots in Fort Bend County. His extensive experience and commitment to justice make him the ideal candidate for the 240th District Court.`,
        imageUrl: '39838a_a43017b268e345708dbd99bf85a22ab1~mv2.avif',
      },
      issues: {
        title: 'Priorities',
        issues: [
          { title: 'Upholding the Constitution', text: 'Todd Frankfort is committed to interpreting the law as it is written and upholding the constitution in every case.' },
          { title: 'Ensuring Fair and Impartial Justice', text: 'Fairness and impartiality are the cornerstones of our justice system. Todd will ensure that everyone who comes before the court is treated with respect and receives a fair hearing.' },
          { title: 'Protecting Our Community', text: 'As a lifelong resident of Fort Bend County, Todd is dedicated to keeping our community safe. He will be a tough but fair judge, holding criminals accountable for their actions.' },
        ],
      },
    },
    about: {
      title: 'About Todd Frankfort',
      text: `Todd Frankfort\'s life and career are a testament to his commitment to public service and the law. He has lived in Fort Bend County for...`, // TODO: Add full bio
      imageUrl: '39838a_a43017b268e345708dbd99bf85a22ab1~mv2.avif',
    },
    issues: {
      title: 'Issues',
      issues: [
        { title: 'Upholding the Constitution', text: 'Todd Frankfort is committed to interpreting the law as it is written and upholding the constitution in every case.' },
        { title: 'Ensuring Fair and Impartial Justice', text: 'Fairness and impartiality are the cornerstones of our justice system. Todd will ensure that everyone who comes before the court is treated with respect and receives a fair hearing.' },
        { title: 'Protecting Our Community', text: 'As a lifelong resident of Fort Bend County, Todd is dedicated to keeping our community safe. He will be a tough but fair judge, holding criminals accountable for their actions.' },
      ],
    },
    endorsements: {
        title: 'Endorsements',
        endorsements: [
        ] // TODO: Add endorsements
    },
    getInvolved: {
      title: 'Get Involved',
      text: 'We need your help to win this election! Sign up to volunteer, request a yard sign, or host an event.',
    },
    contact: {
      title: 'Contact Us',
      text: 'Get in touch with the campaign.',
    },
  },
};

const config = frankfortConfig;

export default config;

export const rootPath = '/';
